/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
    /**
     * show loading status
     */
    loading?: boolean;
    /**
     * display error message
     */
    showError?: boolean;
    /**
     * indicates whether Authorization credentials are required for the request
     * @default true
     */
    withAuthorization?: boolean;
}

export interface IRequestPromise<T = any> extends Promise<IRequestResponse<T>> {}

export interface IRequestResponse<T = any> {
    data: T;
    status: number;
    statusText: string;
    headers: any;
    config: any;
    request?: any;
}

export interface IRequestInstance {
    (config: any): IRequestPromise;
    (url: string, config?: any): IRequestPromise;
    request<T = any>(config: any): IRequestPromise<T>;
}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: IRequestInstance;
    /** only in axios interceptor config*/
    loading: boolean;
    showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error('please inject yourself instance like axios  ');
    }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = {
        loading: serviceOptions.loading,
        showError: serviceOptions.showError,
        ...options,
        method,
        url
    };
    configs.headers = {
        ...options.headers,
        'Content-Type': contentType
    };
    return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class AircraftAirportTestApiService {
    /**
     *
     */
    static getTestSummary(
        params: {
            /** requestBody */
            body?: AirportAircraftTestRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<AircraftAirportTestResponseSummaryModel[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetTestSummary';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static download(
        params: {
            fileName?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/Weather/Download';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { FileName: params['fileName'] };

            axios(configs, resolve, reject);
        });
    }
}

export class AirportsDetailsApiService {
    /**
     *
     */
    static airportDetails(
        params: {
            /** requestBody */
            body?: GetAirportDetailsRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GetAirportDetailsResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/AirportDetails';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static findAirport(
        params: {
            /** requestBody */
            body?: FindAirportRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FindAirportResponseModel[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/FindAirport';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class AirportSummaryApiService {
    /**
     *
     */
    static airportSummary(
        params: {
            icao: string;

            tabId: string;

            tl: string;

            tf: string;

            tz: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/AirportSummary/{ICAO}/{tabID}/{TL}/{TF}/{TZ}';
            url = url.replace('{ICAO}', params['icao'] + '');
            url = url.replace('{tabID}', params['tabId'] + '');
            url = url.replace('{TL}', params['tl'] + '');
            url = url.replace('{TF}', params['tf'] + '');
            url = url.replace('{TZ}', params['tz'] + '');

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export class AirportSummaryBasicApiService {
    /**
     *
     */
    static airportSummaryBasic(
        params: {
            /** requestBody */
            body?: AirportSummaryBasicRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<AirportSummaryBasicResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/AirportSummaryBasic';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class CodeShareApiService {
    /**
     *
     */
    static codeShare(
        params: {
            /** requestBody */
            body?: CodeShareDataRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CodeShareDataResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/CodeShare';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class EmbeddedApiService {
    /**
     *
     */
    static embeddedMap(
        params: {
            apiKey?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/EmbeddedMap';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { APIKey: params['apiKey'] };

            axios(configs, resolve, reject);
        });
    }
}

export class FaatfmApiService {
    /**
     *
     */
    static getFaatfm(options: IRequestOptions = {}): Promise<FEWebTFMGetResponseModelItem> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetFAATFM';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export class FeDrawingObjApiService {
    /**
     *
     */
    static updateDrawing(
        params: {
            uuid: string;
            /** requestBody */
            body?: DrawingObject;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebDrawingssUpdateResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/UpdateDrawing/{UUID}';
            url = url.replace('{UUID}', params['uuid'] + '');

            const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static addDrawing(
        params: {
            /** requestBody */
            body?: DrawingObject;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebDrawingAddResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/AddDrawing';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getDrawing(
        params: {
            lastupdate?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebDrawingGetResponseModelItem> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetDrawing';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { lastupdate: params['lastupdate'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getDrawingForItem(
        params: {
            itemId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebDrawingGetResponseModelItem> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetDrawingForItem';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { ItemID: params['itemId'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static deleteDrawing(
        params: {
            uuid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebDrawingssUpdateResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/DeleteDrawing/{UUID}';
            url = url.replace('{UUID}', params['uuid'] + '');

            const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export class FeedbackApiService {
    /**
     *
     */
    static feedBack(
        params: {
            /** requestBody */
            body?: FeedbackRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FeedbackResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/FeedBack';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static feWebAlert(
        params: {
            /** requestBody */
            body?: AlertRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FeedbackResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/FEWebAlert';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class FeNotesApiService {
    /**
     *
     */
    static updateNotes(
        params: {
            uuid: string;
            /** requestBody */
            body?: FEWebNotesUpdate;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebNotesUpdateResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/UpdateNotes/{UUID}';
            url = url.replace('{UUID}', params['uuid'] + '');

            const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static addNotes(
        params: {
            /** requestBody */
            body?: FEWebNotesUpdate;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebNotesAddResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/AddNotes';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getNotesSummary(options: IRequestOptions = {}): Promise<FEWebNotesGetResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetNotesSummary';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getNotesForItem(
        params: {
            itemId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebNotesGetResponseModelItem> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetNotesForItem';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { ItemID: params['itemId'] };

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static deleteNotes(
        params: {
            uuid: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEWebNotesUpdateResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/DeleteNotes/{UUID}';
            url = url.replace('{UUID}', params['uuid'] + '');

            const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
}

export class FeRouteApiService {
    /**
     *
     */
    static decodeAdhocRoute(
        params: {
            /** requestBody */
            body?: FESingleRouteDecodeRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FESingleRouteDecodeResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/DecodeAdhocRoute';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getRoutes(
        params: {
            /** requestBody */
            body?: FEGetRoutesRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FEMultipleRouteDecodeResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetRoutes';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class FeWebSettingsApiService {
    /**
     *
     */
    static updateFeWebSettings(
        params: {
            /** requestBody */
            body?: FEWebSettingsUpdateModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SetUDViewResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/UpdateFEWebSettings';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getFeWebSettings(
        params: {
            /** requestBody */
            body?: GetUDViewRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GetUDViewResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetFEWebSettings';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class FileUploadApiService {
    /**
     *
     */
    static uploadNavFile(
        params: {
            file: any;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/UploadNavFile';

            const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

            let data = undefined;
            data = new FormData();
            if (params['file']) {
                if (Object.prototype.toString.call(params['file']) === '[object Array]') {
                    for (const item of params['file']) {
                        data.append('file', item as any);
                    }
                } else {
                    data.append('file', params['file'] as any);
                }
            }

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class FlightDetailsApiService {
    /**
     *
     */
    static flightDetails(
        params: {
            /** requestBody */
            body?: GetFlightDetailsRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GetFlightDetailsResponseModel[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/FlightDetails';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class GroupFilterApiService {
    /**
     *
     */
    static updateGroupFilter(
        params: {
            /** requestBody */
            body?: FilterGroupUpdateRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilterGroupUpdateResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/UpdateGroupFilter';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getGroupFilter(
        params: {
            /** requestBody */
            body?: FilterGroupGetRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FilterGroupGetResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetGroupFilter';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class LocationApiService {
    /**
     *
     */
    static lastKnownLocation(
        params: {
            /** requestBody */
            body?: GetLastKnowLocationRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GetLastKnowLocationResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/LastKnownLocation';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getNearestCity(
        params: {
            /** requestBody */
            body?: GetNearestCityRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GetNearestCityResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetNearestCity';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static tailRegistration(
        params: {
            /** requestBody */
            body?: FERegistrationRequestDTO;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FERegistrationResponseDTO> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/TailRegistration';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class LoginApiService {
    /**
     *
     */
    static login(
        params: {
            /** requestBody */
            body?: LoginRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<LoginResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/Login';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static logout(options: IRequestOptions = {}): Promise<LogoutResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/Logout';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static logoutAbort(
        params: {
            /** requestBody */
            body?: LogoutAbortModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<LogoutResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/LogoutAbort';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class MobileStartupApiService {
    /**
     *
     */
    static start(
        params: {
            build?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/Mobile/Start';

            const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
            configs.params = { build: params['build'] };

            axios(configs, resolve, reject);
        });
    }
}

export class MonitorApiService {
    /**
     *
     */
    static getMonitorData(
        params: {
            /** requestBody */
            body?: GetMonitorDataRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GetMonitorDataResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/GetMonitorData';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static uploadMonitorData(
        params: {
            /** requestBody */
            body?: UploadMonitorDataRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<UploadMonitorDataResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/UploadMonitorData';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class NavDataLookupApiService {
    /**
     *
     */
    static findNavData(
        params: {
            /** requestBody */
            body?: FindNavdataRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FindNavdataResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/FindNavData';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export class PasswordChangeApiService {
    /**
     *
     */
    static passwordChange(
        params: {
            /** requestBody */
            body?: PasswordChangeRequestModel;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PasswordChangeResponseModel> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/api/v1/PasswordChange';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

/** AircraftAirportTestResponseModel */
export interface AircraftAirportTestResponseModel {
    id?: string;
    flightStat?: FlightStatusEnum;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
    lastPosUpdate?: string;
    ufid?: string;
}

/** AircraftAirportTestResponseSummaryModel */
export interface AircraftAirportTestResponseSummaryModel {
    activeCount?: number;
    plannedCount?: number;
    scheduledCount?: number;
    statusList?: AircraftAirportTestResponseModel[];
}

/** AircraftDataModel */
export interface AircraftDataModel {
    ufid?: string;
    acid?: string;
    origin?: string;
    dest?: string;
    altitude?: number;
    speed?: number;
    flightStat?: FlightStatusEnum;
    acType?: string;
    monStat?: MonitorStatusEnum;
    regNum?: string;
    distPercent?: number;
    destAlt1?: string;
    destAlt2?: string;
    fob?: number;
    fobUnit?: FOBUnitEnum;
    holding?: boolean;
    diverting?: boolean;
    onGround?: boolean;
    lastDest?: string;
    deskID?: string;
    depTime?: string;
    arrTime?: string;
    out?: string;
    off?: string;
    on?: string;
    in?: string;
    lastPosUpdate?: string;
    lastFullUpdate?: string;
    aircraftThresholds?: AircraftThresholdModel[];
}

/** AircraftThresholdAlertOptions */
export interface AircraftThresholdAlertOptions {
    eventList?: boolean;
    eventListAck?: boolean;
    eventListImportant?: boolean;
    eMail?: boolean;
    logFile?: boolean;
    popup?: boolean;
    osAlert?: boolean;
    aircraftTag?: boolean;
    zoomToAircraft?: boolean;
    overrideColor?: boolean;
    enableMarker?: boolean;
    voice?: boolean;
    playSound?: boolean;
    overrideColorHex?: string;
    alertOnScheduled?: boolean;
    alertOnPlanned?: boolean;
    alertOnActive?: boolean;
}

/** AircraftThresholdItemModel */
export interface AircraftThresholdItemModel {
    type?: AircraftThresholdType;
    priority?: number;
    enableState?: ThresholdEnableState;
    info?: AircraftThresholdLevelModel;
    watch?: AircraftThresholdLevelModel;
    warning?: AircraftThresholdLevelModel;
    critical?: AircraftThresholdLevelModel;
    emergency?: AircraftThresholdLevelModel;
    alerts?: AircraftThresholdAlertOptions;
    ignoredTemplateLevels?: ThresholdLevel[];
}

/** AircraftThresholdLevelModel */
export interface AircraftThresholdLevelModel {
    repeat?: boolean;
    triggerOnImproving?: boolean;
    value?: number;
    unitIndex?: number;
    actionType?: ThresholdLevelActionType;
    actionTimeMinutes?: number;
}

/** AircraftThresholdModel */
export interface AircraftThresholdModel {
    type?: AircraftThresholdTypeEnum;
    triggerVal?: string;
    actualVal?: string;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
}

/** AirportAircraftTestRequestModel */
export interface AirportAircraftTestRequestModel {
    dmGroupID?: string;
    seqNum?: number;
    queryType?: number;
}

/** AirportDataModel */
export interface AirportDataModel {
    icao?: string;
    iata?: string;
    name?: string;
    lat?: number;
    lon?: number;
    orgCount?: number;
    dstCount?: number;
    altCount?: number;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
    airportThresholds?: AirportThresholdModel[];
}

/** AirportDelayModel */
export interface AirportDelayModel {
    delayType?: AirportDelayTypeEnum;
    creationTime?: string;
    updateTime?: string;
    reason?: string;
    startTime?: string;
    endTime?: string;
    minDelay?: number;
    maxDelay?: number;
    trend?: AirportDelayTrendEnum;
    colorCode?: string;
}

/** AirportMonitorStatusInclude */
export interface AirportMonitorStatusInclude {
    originThresholds?: boolean;
    destinationThresholds?: boolean;
    alternateThresholds?: boolean;
}

/** AirportSummaryBasicRequestModel */
export interface AirportSummaryBasicRequestModel {
    icao?: string;
}

/** AirportSummaryBasicResponseModel */
export interface AirportSummaryBasicResponseModel {
    airportDetailsResponseModel?: GetAirportDetailsResponseModel;
    airportWeatherResponseModel?: AirportWeatherResponseModel;
    delay?: AirportDelayModel[];
}

/** AirportThresholdAlertOptions */
export interface AirportThresholdAlertOptions {
    eventList?: boolean;
    eventListAck?: boolean;
    eventListImportant?: boolean;
    eMail?: boolean;
    logFile?: boolean;
    popup?: boolean;
    osAlert?: boolean;
    aircraftTag?: boolean;
    zoomToAircraft?: boolean;
    overrideColor?: boolean;
    enableMarker?: boolean;
    voice?: boolean;
    playSound?: boolean;
    overrideColorHex?: string;
}

/** AirportThresholdGroupModel */
export interface AirportThresholdGroupModel {
    airportId?: string;
    usage?: AirportThresholdGroupUsage;
    thresholds?: AirportThresholdItemModel[];
    autoGenerated?: boolean;
    isOff?: boolean;
}

/** AirportThresholdItemModel */
export interface AirportThresholdItemModel {
    type?: AirportThresholdType;
    enableState?: ThresholdEnableState;
    info?: AircraftThresholdLevelModel;
    watch?: AircraftThresholdLevelModel;
    warning?: AircraftThresholdLevelModel;
    critical?: AircraftThresholdLevelModel;
    emergency?: AircraftThresholdLevelModel;
    offInheritedLevels?: ThresholdLevel[];
}

/** AirportThresholdModel */
export interface AirportThresholdModel {
    type?: AirportThresholdTypeEnum;
    triggerVal?: string;
    actualVal?: string;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
}

/** AirportThresholdSettingsItemModel */
export interface AirportThresholdSettingsItemModel {
    type?: AirportThresholdType;
    priority?: number;
    alerts?: AirportThresholdAlertOptions;
}

/** AirportThresholdsModel */
export interface AirportThresholdsModel {
    thresholds?: AirportThresholdGroupModel[];
    options?: AirportThresholdSettingsItemModel[];
}

/** AirportWeatherResponseModel */
export interface AirportWeatherResponseModel {
    temp?: number;
    windSpeed?: number;
    windDir?: string;
    weatherIcon?: string;
    weatherStatus?: WeatherMetarEnum;
    weatherText?: string;
}

/** AlernateAirportModel */
export interface AlernateAirportModel {
    id?: string;
}

/** AlertFilterModel */
export interface AlertFilterModel {
    emergencyBeaconCode?: boolean;
    diverting?: boolean;
    holding?: boolean;
    timeSinceLastRepPos?: boolean;
    faaClosure?: boolean;
    groundStop?: boolean;
}

/** AlertRequestModel */
export interface AlertRequestModel {
    nameOfSender?: string;
    toEmails?: string[];
    bccEmails?: string[];
    ccEmails?: string[];
    alertType?: AlertEnum;
    alertHtmlContent?: string;
    alertSubject?: string;
}

/** BaseMapModel */
export interface BaseMapModel {
    ver?: number;
    buildDt?: string;
    urlToken?: string;
}

/** CodeShareDataRequestModel */
export interface CodeShareDataRequestModel {
    carrierACID?: string;
}

/** CodeShareDataResponseModel */
export interface CodeShareDataResponseModel {
    carrierACID?: string;
    operatorACID?: string;
}

/** CompanyMonitorSettingsSet */
export interface CompanyMonitorSettingsSet {
    currentFEWebVersion?: string;
    currentDbFEWebVersion?: number;
    originalFEWebVersion?: string;
    originalDbFEWebVersion?: number;
    id?: string;
    lastUpdate?: string;
    monitorOptions?: MonitorOptionsModel;
    airportThresholds?: AirportThresholdsModel;
    aircraftThresholds?: AircraftThresholdItemModel[];
    Type?: MonitorSettingsType;
    companyMode?: CompanyThresholdsMode;
}

/** DevicePropertyModel */
export interface DevicePropertyModel {
    model?: string;
    deviceMan?: string;
    osVersion?: string;
    platform?: string;
    feMobileVersion?: string;
    uniqueDeviceID?: string;
    uniqueAppInstallationID?: string;
}

/** DrawingObject */
export interface DrawingObject {
    id?: string;
    name?: string;
    type?: DrawingObjectType;
    isCompany?: boolean;
    label?: DrawingObjectLabelSettings;
    line?: DrawingObjectLineSettings;
    fill?: DrawingObjectFillSettings;
    center?: DrawingObjectCenterSettings;
    zoom?: DrawingObjectZoomSettings;
    category?: DrawingObjectCategory;
    altitude?: DrawingObjectAltitudeRange;
    geometry?: DrawingObjectGeometry;
    alerts?: DrawingObjectAlerts;
    validTime?: DrawingObjectValidTimeSettings;
    fpmProperties?: DrawingObjectFPMProperties;
    deleted?: boolean;
}

/** DrawingObjectAlerts */
export interface DrawingObjectAlerts {
    plane?: boolean;
    route?: boolean;
}

/** DrawingObjectAltitudeRange */
export interface DrawingObjectAltitudeRange {
    min?: number;
    max?: number;
}

/** DrawingObjectCenterSettings */
export interface DrawingObjectCenterSettings {
    style?: DrawingObjectCenterStyle;
    color?: string;
    size?: number;
}

/** DrawingObjectFPMProperties */
export interface DrawingObjectFPMProperties {
    sync?: boolean;
    FPMSyncType?: FPMSync;
}

/** DrawingObjectFillSettings */
export interface DrawingObjectFillSettings {
    color?: string;
    style?: DrawingObjectFillStyle;
}

/** DrawingObjectGeometry */
export interface DrawingObjectGeometry {
    centerUnits?: DrawingObjectCenterUnits;
    centerX?: number;
    centerY?: number;
    radiusUnits?: DrawingObjectOffsetUnits;
    radiusX?: number;
    radiusY?: number;
    sizeUnits?: DrawingObjectOffsetUnits;
    width?: number;
    height?: number;
    polygonCoordinates?: number[][]; // Axios generator did this wrong
}

/** DrawingObjectLabelSettings */
export interface DrawingObjectLabelSettings {
    text?: string;
    alignment?: DrawingObjectLabelAlignment;
    color?: string;
}

/** DrawingObjectLineSettings */
export interface DrawingObjectLineSettings {
    style?: DrawingObjectLineType;
    width?: number;
    color?: string;
}

/** DrawingObjectValidTimeSettings */
export interface DrawingObjectValidTimeSettings {
    startDay?: string;
    endDay?: string;
    startTime?: string;
    endTime?: string;
    activeDaysOfWeek?: DayOfWeek;
    greyOutNonActive?: boolean;
}

/** DrawingObjectZoomSettings */
export interface DrawingObjectZoomSettings {
    object?: number;
    point?: number;
    label?: number;
}

/** ETOPSModel */
export interface ETOPSModel {
    bt?: number;
    bd?: number;
    rt?: number;
    rd?: number;
    apt?: FlightPlanAirport[];
    pnt?: FlightPlanPoint[];
}

/** EmergencyBeaconCodeModel */
export interface EmergencyBeaconCodeModel {
    code?: number;
    text?: string;
}

/** FAADelayModel */
export interface FAADelayModel {
    type?: FAADelayTypeEnum;
    airportID?: string;
    createTime?: string;
    updateTime?: string;
    reason?: string;
    startTime?: string;
    stopTime?: string;
    averageOrMinDelay?: number;
    maxDelay?: number;
    trend?: FAADelayTrendEnum;
    airportName?: string;
    airportLat?: number;
    airportLon?: number;
}

/** FCAModel */
export interface FCAModel {
    shape?: ShapeTypeEnum;
    condition?: FCAConditionEnum;
    startTime?: string;
    endTime?: string;
    afpStartTime?: string;
    afpEndTime?: string;
    type?: FCAType;
    color?: number;
    lookAheadTime?: number;
    ceiling?: number;
    floor?: number;
    avgDelay?: number;
    direction?: number;
    speed?: number;
    centerLatitude?: number;
    centerLongitude?: number;
    radius?: number;
    fcApoints?: FCApointModel[];
    nasName?: string;
    label?: string;
    detail?: string;
    filter?: string;
}

/** FCApointModel */
export interface FCApointModel {
    lat?: number;
    lon?: number;
}

/** FEGetRoutesRequestModel */
export interface FEGetRoutesRequestModel {
    reqType?: RouteRquestTypeEnum;
    originID?: string;
    destID?: string;
}

/** FEMonitorSettingsModel */
export interface FEMonitorSettingsModel {
    company?: CompanyMonitorSettingsSet;
    user?: UserMonitorSettingsSet;
}

/** FEMultipleRouteDecodeResponseModel */
export interface FEMultipleRouteDecodeResponseModel {
    responseCode?: number;
    prefroutes?: PrefCodedRouteModel[];
    codedroutes?: PrefCodedRouteModel[];
}

/** FERegistrationRequestDTO */
export interface FERegistrationRequestDTO {
    id?: string;
}

/** FERegistrationResponseDTO */
export interface FERegistrationResponseDTO {
    registrationNumber?: string;
    serialNumber?: string;
    yearManufactured?: string;
    registrantType?: string;
    registrantName?: string;
    registrantStreet1?: string;
    registrantStreet2?: string;
    registrantCity?: string;
    registrantState?: string;
    registrantZipCode?: string;
    registrantRegion?: string;
    registrantCounty?: string;
    registrantCountryCode?: string;
    lastActivityDate?: string;
    cetificateIssueDate?: string;
    airworthinessClassification?: string;
    approvedOperation?: string;
    airworthinessDate?: string;
    status?: string;
    modeSTransponderCode?: string;
    fractionalOwnership?: string;
    aircraftManufacturerName?: string;
    aircraftManufacturerCode?: string;
    aircraftModelName?: string;
    aircraftModelCode?: string;
    aircraftSeriesCode?: string;
    aircraftType?: string;
    aircraftCategoryCode?: string;
    builderCertificationcode?: string;
    numberOfEngines?: string;
    numberOfSeats?: string;
    aircraftWeight?: string;
    aircraftCruisingSpeed?: string;
    engineManufacturerName?: string;
    engineManufacturerCode?: string;
    engineModelName?: string;
    engineModelCode?: string;
    engineType?: string;
    engineHorsepower?: string;
    poundsofThrust?: string;
}

/** FESingleRouteDecodeRequestModel */
export interface FESingleRouteDecodeRequestModel {
    routes?: string[];
}

/** FESingleRouteDecodeResponseModel */
export interface FESingleRouteDecodeResponseModel {
    responseCode?: number;
    routes?: RouteModel[];
}

/** FEWebDrawingAddResponseModel */
export interface FEWebDrawingAddResponseModel {
    responseCode?: number;
    id?: string;
}

/** FEWebDrawingGet */
export interface FEWebDrawingGet {
    dateCreated?: string;
    createdBy?: string;
    editedBy?: string;
    dateEdited?: string;
    object?: DrawingObject;
}

/** FEWebDrawingGetResponseModelItem */
export interface FEWebDrawingGetResponseModelItem {
    responseCode?: number;
    drawings?: FEWebDrawingGet[];
    deleted?: string[];
}

/** FEWebDrawingssUpdateResponseModel */
export interface FEWebDrawingssUpdateResponseModel {
    responseCode?: number;
}

/** FEWebNotesAddResponseModel */
export interface FEWebNotesAddResponseModel {
    responseCode?: number;
    id?: string;
}

/** FEWebNotesGet */
export interface FEWebNotesGet {
    id?: string;
    type?: NoteType;
    itemId?: string;
    content?: string;
    origin?: string;
    depDateTime?: string;
    etaDate?: string;
    dateCreated?: string;
    createdBy?: string;
    editedBy?: string;
    dateEdited?: string;
    isCompany?: boolean;
}

/** FEWebNotesGetResponseModel */
export interface FEWebNotesGetResponseModel {
    responseCode?: number;
    airlines?: string[];
    airports?: string[];
    tails?: string[];
}

/** FEWebNotesGetResponseModelItem */
export interface FEWebNotesGetResponseModelItem {
    responseCode?: number;
    notes?: FEWebNotesGet[];
}

/** FEWebNotesUpdate */
export interface FEWebNotesUpdate {
    type?: NoteType;
    itemId?: string;
    content?: string;
    origin?: string;
    depDateTime?: string;
    etaDate?: string;
    isCompany?: boolean;
}

/** FEWebNotesUpdateResponseModel */
export interface FEWebNotesUpdateResponseModel {
    responseCode?: number;
}

/** FEWebSettingModel */
export interface FEWebSettingModel {
    currentFEWebVersion?: string;
    currentDbFEWebVersion?: number;
    originalFEWebVersion?: string;
    originalDbFEWebVersion?: number;
    id?: string;
    lastUpdate?: string;
    settings?: SettingsItem[];
}

/** FEWebSettingsUpdateModel */
export interface FEWebSettingsUpdateModel {
    udViewList?: UDViewModel[];
    monitorSettings?: FEMonitorSettingsModel;
    feWebSettings?: FEWebSettingModel;
}

/** FEWebTFMGetResponseModelItem */
export interface FEWebTFMGetResponseModelItem {
    responseCode?: number;
    fcaLastupdte?: string;
    rerouteLastUpdate?: string;
    faaDelayLastUpdate?: string;
    fcas?: FCAModel[];
    reroutes?: RerouteDTOModel[];
    delays?: FAADelayModel[];
}

/** FeedbackRequestModel */
export interface FeedbackRequestModel {
    name?: string;
    phoneNumber?: string;
    email?: string;
    feedbackType?: FeedbackEnum;
    feedBack?: string;
}

/** FeedbackResponseModel */
export interface FeedbackResponseModel {
    responseCode?: number;
}

/** FilterGroup */
export interface FilterGroup {
    id?: string;
    name?: string;
    type?: FilterGroupType;
    members?: string[];
    isCompany?: boolean;
    lastUpdate?: string;
}

/** FilterGroupGetRequestModel */
export interface FilterGroupGetRequestModel {
    lastUpdate?: string;
}

/** FilterGroupGetResponseModel */
export interface FilterGroupGetResponseModel {
    responseCode?: number;
    groups?: FilterGroup[];
    delete?: string[];
}

/** FilterGroupUpdateRequestModel */
export interface FilterGroupUpdateRequestModel {
    add?: FilterGroup[];
    update?: FilterGroup[];
    delete?: string[];
}

/** FilterGroupUpdateResponseModel */
export interface FilterGroupUpdateResponseModel {
    responseCode?: number;
}

/** FindAirportRequestModel */
export interface FindAirportRequestModel {
    searchText?: string;
}

/** FindAirportResponseModel */
export interface FindAirportResponseModel {
    icao?: string;
    iata?: string;
    faa?: string;
    name?: string;
    lat?: number;
    lon?: number;
    city?: string;
    state?: string;
    country?: string;
    matchType?: number;
}

/** FindNavdataRequestModel */
export interface FindNavdataRequestModel {
    searchText?: string;
}

/** FindNavdataResponseModel */
export interface FindNavdataResponseModel {
    fixes?: GenericNavdataResponseModel[];
    navaids?: GenericNavdataResponseModel[];
    airways?: GenericNavdataResponseModel[];
}

/** FlightPlanAirport */
export interface FlightPlanAirport {
    aft?: eEtopsAirportFunctionTypeEnum;
    icaoId?: string;
    iataId?: string;
}

/** FlightPlanPoint */
export interface FlightPlanPoint {
    pt?: PointTypeEnum;
    pn?: string;
    lat?: number;
    lon?: number;
    ct?: number;
    fob?: number;
    fu?: FOBunitTypeEnum;
    bai?: number;
    aai?: number;
}

/** GenericNavdataResponseModel */
export interface GenericNavdataResponseModel {
    id?: string;
    navType?: NavTypeEnum;
    name?: string;
    lat?: number;
    lon?: number;
}

/** GetAirportDetailsRequestModel */
export interface GetAirportDetailsRequestModel {
    icao?: string;
}

/** GetAirportDetailsResponseModel */
export interface GetAirportDetailsResponseModel {
    icao?: string;
    iata?: string;
    faa?: string;
    name?: string;
    lat?: number;
    lon?: number;
    city?: string;
    state?: string;
    country?: string;
    distance?: number;
    direction?: string;
    magVar?: string;
    elevation?: number;
    type?: AirportType;
    longestRwy?: string;
    longestRwyLength?: number;
    observeDst?: boolean;
    tzOffset?: number;
    tzName?: string;
    faaarffClass?: number;
    faaarffIndex?: string;
    icaoarffClass?: string;
}

/** GetFlightDetailsRequestModel */
export interface GetFlightDetailsRequestModel {
    ufid?: string;
    acidType?: FlightDetailsEnum;
    acid?: string;
}

/** GetFlightDetailsResponseModel */
export interface GetFlightDetailsResponseModel {
    acid?: string;
    origin?: string;
    dest?: string;
    odt?: string;
    ota?: string;
    altitude?: number;
    speed?: number;
    lat?: number;
    lon?: number;
    flightStat?: FlightStatusEnum;
    acType?: string;
    regNum?: string;
    edt?: string;
    eta?: string;
    pdt?: string;
    pta?: string;
    currentRoute?: string;
    routeDate?: string;
    plannedAltitude?: number;
    lastDest?: string;
    isDelayed?: boolean;
    beaconCode?: string;
    modeSID?: string;
    distPercent?: number;
}

/** GetLastKnowLocationRequestModel */
export interface GetLastKnowLocationRequestModel {
    id?: string;
    type?: GetLastKnowLocationTypeEnum;
}

/** GetLastKnowLocationResponseModel */
export interface GetLastKnowLocationResponseModel {
    dateAtLoc?: string;
    destination?: string;
    origin?: string;
    latitude?: number;
    longitude?: number;
    isAtDest?: number;
    actype?: string;
    nearestCity?: string;
    distanceFromCity?: number;
    bearingFromCity?: number;
}

/** GetMonitorDataRequestModel */
export interface GetMonitorDataRequestModel {
    lastUpdateTime?: string;
}

/** GetMonitorDataResponseModel */
export interface GetMonitorDataResponseModel {
    responseCode?: number;
    lastUpdateTime?: string;
    aircraftList?: AircraftDataModel[];
    airportList?: AirportDataModel[];
}

/** GetNearestCityRequestModel */
export interface GetNearestCityRequestModel {
    lat?: number;
    lon?: number;
}

/** GetNearestCityResponseModel */
export interface GetNearestCityResponseModel {
    nearestCity?: string;
    distanceFromCity?: number;
    bearingFromCity?: number;
}

/** GetUDViewRequestModel */
export interface GetUDViewRequestModel {
    mon?: boolean;
    udView?: boolean;
    webSetting?: boolean;
    lastUDViewUpdateTime?: string;
    lastMonitorSettingUpdateTime?: string;
    lastWebSettingUpdateTime?: string;
}

/** GetUDViewResponseModel */
export interface GetUDViewResponseModel {
    responseCode?: number;
    udViewList?: UDViewModel[];
    monitorSettings?: FEMonitorSettingsModel;
    feWebSettings?: FEWebSettingModel;
}

/** ImpactsModel */
export interface ImpactsModel {}

/** IntegrationRights */
export interface IntegrationRights {
    hasFPMIntegrationRight?: boolean;
    hasDesktopIntegrationRight?: boolean;
}

/** LoginRequestModel */
export interface LoginRequestModel {
    userID?: string;
    password?: string;
    refreshToken?: string;
    deviceProperties?: DevicePropertyModel;
    notificationID?: string;
    alertFilter?: AlertFilterModel;
    usageType?: UsageTypeEnum;
}

/** LoginResponseModel */
export interface LoginResponseModel {
    responseCode?: number;
    isClientVersionSupported?: boolean;
    accessToken?: string;
    refreshToken?: string;
    expiresAt?: string;
    dmGroupId?: string;
    seqNum?: number;
    clientType?: ClientTypeEnum;
    canUpdatePwd?: boolean;
    isScheduleFlightsEnabled?: boolean;
    hasRight?: boolean;
    rightsExpiration?: string;
    wmsPasscode?: string;
    airlineList?: string[];
    callsignList?: string[];
    navMapList?: NavMapModel[];
    baseMapList?: BaseMapModel[];
    tileDNS?: string;
    integrationRights?: IntegrationRights;
}

/** LogoutAbortModel */
export interface LogoutAbortModel {
    token?: string;
}

/** LogoutResponseModel */
export interface LogoutResponseModel {
    responseCode?: number;
}

/** MonitorImpactsDistanceSettings */
export interface MonitorImpactsDistanceSettings {
    volcanicAsh?: number;
    sigmet?: number;
    convSigment?: number;
    dsua?: number;
    edrTurbulence?: number;
    turbulence?: number;
    icing?: number;
    contrail?: number;
    tcf?: number;
}

/** MonitorOptionsModel */
export interface MonitorOptionsModel {
    monitorOriginDepartureMinMinutes?: number;
    monitorOriginWithoutDepartureTime?: boolean;
    monitorDestinationDepartureMinMinutes?: number;
    monitorDestinationWithoutArrivalTime?: boolean;
    monitorAltDepartureMinMinutes?: number;
    monitorAltWithoutArrivalTime?: boolean;
    emergencyBeacons?: EmergencyBeaconCodeModel[];
    ignoredCompanyBeaconCodes?: number[];
    altitudeChangeWindowMinutes?: number;
    suppressAltitudeMonitorMiles?: number;
    monitorImpactDistance?: MonitorImpactsDistanceSettings;
    tafWindowHours?: number;
    airportMonitorStatusInclude?: AirportMonitorStatusInclude;
}

/** NavMapModel */
export interface NavMapModel {
    company?: string;
    seq?: number;
    ver?: number;
    cycleDt?: string;
    buildDt?: string;
    urlToken?: string;
}

/** PasswordChangeRequestModel */
export interface PasswordChangeRequestModel {
    oldPassword?: string;
    newPassword?: string;
}

/** PasswordChangeResponseModel */
export interface PasswordChangeResponseModel {
    responseCode?: number;
}

/** PrefCodedRouteModel */
export interface PrefCodedRouteModel {
    seq?: string;
    label?: string;
    originID?: string;
    destID?: string;
    isDecoded?: boolean;
    route?: RouteModel;
}

/** RerouteDTOModel */
export interface RerouteDTOModel {
    bitmap?: BITMAPEnum;
    advisoryNumber?: string;
    advisoryCategory?: AdvisoryCategoryEnum;
    advisoryAction?: AdvisoryActionEnum;
    rerouteLastUpdate?: string;
    rerouteCreated?: string;
    rerouteStartTime?: string;
    rerouteEndTime?: string;
    lastFlightListUpdate?: string;
    fcaName?: string;
    fcaStartTime?: string;
    fcaEndTime?: string;
    rerouteName?: string;
    detail?: string;
    routes?: routeTypeDTOModdel[];
    routeText?: string[];
}

/** RouteModel */
export interface RouteModel {
    rs?: RouteSourceEnum;
    rt?: RouteTypeEnum;
    au?: AltUnitEnum;
    fu?: FuelUnitEnum;
    su?: SpeedUnitEnum;
    wu?: WindUnitEnum;
    sn?: number;
    ts?: string;
    fd?: FeedTypeEnum;
    rtxt?: string;
    ca?: number;
    wp?: WaypointModel[];
    im?: ImpactsModel[];
    etops?: ETOPSModel;
    alt?: AlernateAirportModel[];
    we?: WeatherModel;
    dst?: number;
    ete?: number;
}

/** SetUDViewResponseModel */
export interface SetUDViewResponseModel {
    responseCode?: number;
}

/** SettingsItem */
export interface SettingsItem {
    key?: string;
    value?: string;
}

/** UDViewAirportModel */
export interface UDViewAirportModel {
    show?: boolean;
    tower?: boolean;
    noTower?: boolean;
    heliport?: boolean;
    seaplane?: boolean;
    others?: boolean;
    runways?: boolean;
    deicing?: boolean;
    filterGroup?: UDViewFilterGroupModel;
    settings?: UDViewCommonSettingsItem[];
}

/** UDViewAirspaceModel */
export interface UDViewAirspaceModel {
    show?: boolean;
    fir?: boolean;
    uir?: boolean;
    classA?: boolean;
    classB?: boolean;
    classC?: boolean;
    classD?: boolean;
    classE?: boolean;
    classF?: boolean;
    classG?: boolean;
    other?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewAirwayModel */
export interface UDViewAirwayModel {
    show?: boolean;
    high?: boolean;
    low?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewCommonSettingsItem */
export interface UDViewCommonSettingsItem {
    key?: string;
    value?: string;
}

/** UDViewDrawingObjectModel */
export interface UDViewDrawingObjectModel {
    show?: boolean;
    avoidance?: boolean;
    alert?: boolean;
    view?: boolean;
    viewObjectIds?: string[];
}

/** UDViewFilterGroupModel */
export interface UDViewFilterGroupModel {
    show?: boolean;
    filterGroupIds?: string[];
}

/** UDViewFixesModel */
export interface UDViewFixesModel {
    show?: boolean;
    latLon?: boolean;
    nrs?: boolean;
    aacaA_SUA?: boolean;
    intersection?: boolean;
    rnav?: boolean;
    terminal?: boolean;
    vfr?: boolean;
    other?: boolean;
    low?: boolean;
    high?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewFlightServiceStationModel */
export interface UDViewFlightServiceStationModel {
    show?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewGeographyMapModel */
export interface UDViewGeographyMapModel {
    drawDayNight?: boolean;
}

/** UDViewGridMoraModel */
export interface UDViewGridMoraModel {
    show?: boolean;
}

/** UDViewHoldingModel */
export interface UDViewHoldingModel {
    show?: boolean;
    lowAltitude?: boolean;
    highAltitude?: boolean;
    sid?: boolean;
    star?: boolean;
    approach?: boolean;
    missedApproach?: boolean;
    other?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewLatLonModel */
export interface UDViewLatLonModel {
    show?: boolean;
}

/** UDViewMapModel */
export interface UDViewMapModel {
    dayNightShading?: boolean;
    dayNightShadingType?: UDViewDayNightShadingType;
    selectedTwilightTypes?: UDViewDayNightTwilightType;
    lat?: number;
    lon?: number;
    pitch?: number;
    bearing?: number;
    zoom?: number;
    terrain?: boolean;
    style?: UDViewMapStyle;
    defaultSky?: UDViewMapSkyModel;
    useGlobeView?: boolean;
    globeViewSky?: UDViewMapSkyModel;
}

/** UDViewMapSkyModel */
export interface UDViewMapSkyModel {
    skyColor?: string;
    skyHorizonBlend?: number;
    horizonColor?: string;
    horizonFogBlend?: number;
    fogColor?: string;
    fogGroundBlend?: number;
    atmosphereBlend?: number;
}

/** UDViewMiscellaneousModel */
export interface UDViewMiscellaneousModel {
    backGroundBrightness?: number;
}

/** UDViewModel */
export interface UDViewModel {
    currentFEWebVersion?: string;
    currentDbFEWebVersion?: number;
    originalFEWebVersion?: string;
    originalDbFEWebVersion?: number;
    name?: string;
    id?: string;
    lastUpdate?: string;
    deleted?: boolean;
    type?: UDViewType;
    includeInSlideshow?: boolean;
    isFavorite?: boolean;
    plane?: UDViewPlaneModel;
    weather?: UDViewWeatherModel;
    staticData?: UDViewStaticDataModel;
    map?: UDViewMapModel;
}

/** UDViewNavaidsModel */
export interface UDViewNavaidsModel {
    show?: boolean;
    ndb?: boolean;
    vor?: boolean;
    voR_DME?: boolean;
    vortac?: boolean;
    tacan?: boolean;
    dme?: boolean;
    ndB_DME?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewOverwaterAreasModel */
export interface UDViewOverwaterAreasModel {
    show?: boolean;
}

/** UDViewPlaneFilterListModel */
export interface UDViewPlaneFilterListModel {
    useFilters?: boolean;
    startWithNoPlanes?: boolean;
    planeFilterAutoZoom?: UDViewPlaneFilterAutoZoomEnum;
    planeFilterSettings?: UDViewPlaneFilterSettingModel[];
}

/** UDViewPlaneFilterSettingModel */
export interface UDViewPlaneFilterSettingModel {
    name?: string;
    color?: string;
    isActive?: boolean;
    include?: boolean;
    airlineType?: UDViewPlaneFilterAirlineTypeEnum;
    useMyFleet?: boolean;
    acid?: string;
    origin?: string;
    destination?: string;
    destinationType?: UDViewDestinationTypeEnum;
    useAltAirport?: boolean;
    beaconCode?: string;
    icaoCode?: string;
    altitudeLower?: number;
    altitudeUpper?: number;
    speedLower?: number;
    speedUpper?: number;
    aircraftType?: string;
    filterObjectType?: UDViewFlightFilterObjectEnum;
    timeBefore?: number;
    timeAfter?: number;
    timeType?: UDViewTimeFilterTypeEnum;
    distanceToDestination?: number;
    sectorDeskId?: string;
    tail?: string;
    diverted?: boolean;
    holding?: boolean;
    showTags?: boolean;
    showHistory?: boolean;
    tagTextColor?: UDViewTagFilterColor;
}

/** UDViewPlaneIconSettingModel */
export interface UDViewPlaneIconSettingModel {
    zoomLevel?: number;
    size?: UDViewPlaneIconSizeEnum;
    type?: UDViewPlaneIconTypeEnum;
    drawShadow?: boolean;
}

/** UDViewPlaneModel */
export interface UDViewPlaneModel {
    settings?: UDViewPlaneSettingModel;
    filter?: UDViewPlaneFilterListModel;
    icon?: UDViewPlaneIconSettingModel;
    tag?: UDViewPlaneTagModel;
    range?: UDViewPlaneRangeModel;
    vector?: UDViewPlaneVectorModel;
}

/** UDViewPlaneRangeModel */
export interface UDViewPlaneRangeModel {
    isVisible?: boolean;
    factor?: number;
    type?: UDViewRangeType;
    color?: string;
    lineColor?: string;
}

/** UDViewPlaneSettingModel */
export interface UDViewPlaneSettingModel {
    show?: boolean;
    showHistory?: boolean;
    showActive?: boolean;
    showParked?: boolean;
    showScheduled?: boolean;
    showPlanned?: boolean;
    showDiversionLines?: boolean;
    showGroundVehicles?: boolean;
    historyColor?: string;
    parkedColor?: string;
    scheduledColor?: string;
    plannedColor?: string;
    flightPlanColor?: string;
    oldFlightPlanColor?: string;
    routeLabelsColor?: string;
    routeFlownColor?: string;
    flown3PdiColor?: string;
    flownProjectionColor?: string;
    showFlightPlanPointMark?: boolean;
    showFlightPlanPointLabel?: boolean;
    flightPlanExtent?: boolean;
    showRouteFlownPointMark?: boolean;
    showFlightPlanTime?: UDViewShowFlightPlanTimeEnum;
    showProjectedPoints?: boolean;
    showLastReal?: boolean;
    showProjectedHighlight?: boolean;
    projectedHighlightColor?: string;
    enableCoastMode?: boolean;
    showCoastPosition?: boolean;
    coastPositionColor?: string;
    enableTimeDistance?: boolean;
    udViewTimeDistanceMode?: UDViewTimeDistanceMode;
}

/** UDViewPlaneTagLabelModel */
export interface UDViewPlaneTagLabelModel {
    type?: UDViewTagSelectionEnum;
    label?: string;
    row?: number;
    col?: number;
    enabled?: boolean;
}

/** UDViewPlaneTagModel */
export interface UDViewPlaneTagModel {
    show?: boolean;
    labels?: UDViewPlaneTagLabelModel[];
    zoomLevel?: number;
    disableTagLeader?: boolean;
    enableAutoTag?: boolean;
    tagShowMyNotesIcon?: boolean;
    hideAirlineId?: boolean;
    showLabelBackground?: boolean;
    backgroundColor?: string;
    tagOutlineMode?: UDViewTagOutlineMode;
    tagOutlineColor?: string;
    textColor?: string;
}

/** UDViewPlaneVectorModel */
export interface UDViewPlaneVectorModel {
    isVisible?: boolean;
    factor?: number;
    type?: UDViewRangeType;
    lineColor?: string;
}

/** UDViewSUAModel */
export interface UDViewSUAModel {
    show?: boolean;
    static?: boolean;
    dynamic?: boolean;
    alert?: boolean;
    caution?: boolean;
    danger?: boolean;
    militaryArea?: boolean;
    prohibited?: boolean;
    restricted?: boolean;
    traning?: boolean;
    warning?: boolean;
    unkown?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewSidsModel */
export interface UDViewSidsModel {
    show?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewStarsModel */
export interface UDViewStarsModel {
    show?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UDViewStaticDataModel */
export interface UDViewStaticDataModel {
    airport?: UDViewAirportModel;
    airspace?: UDViewAirspaceModel;
    airway?: UDViewAirwayModel;
    drawingObjects?: UDViewDrawingObjectModel;
    fixes?: UDViewFixesModel;
    flightServiceStation?: UDViewFlightServiceStationModel;
    geographyMap?: UDViewGeographyMapModel;
    holding?: UDViewHoldingModel;
    gridMora?: UDViewGridMoraModel;
    latLon?: UDViewLatLonModel;
    navaids?: UDViewNavaidsModel;
    overwaterAreas?: UDViewOverwaterAreasModel;
    miscellaneous?: UDViewMiscellaneousModel;
    sids?: UDViewSidsModel;
    stars?: UDViewStarsModel;
    sua?: UDViewSUAModel;
    timeZone?: UDViewTimeZoneModel;
    weatherStation?: UDViewWeatherStationModel;
}

/** UDViewTimeZoneModel */
export interface UDViewTimeZoneModel {
    show?: boolean;
}

/** UDViewWeatherModel */
export interface UDViewWeatherModel {
    show?: boolean;
    WeatherList?: number[];
    hidden?: number[];
    tempWindDepiction?: UDViewWindDepiction;
    tempHeatmapStyle?: UDViewHeatMapStyle;
    tempParticleColor?: UDViewWindParticleColor;
    tempHeatmapOpacity?: number;
    tempAltitude?: number;
    settings?: UDViewWeatherSettingsItem[];
}

/** UDViewWeatherSettingsItem */
export interface UDViewWeatherSettingsItem {
    key?: string;
    value?: string;
}

/** UDViewWeatherStationModel */
export interface UDViewWeatherStationModel {
    show?: boolean;
    filterGroup?: UDViewFilterGroupModel;
}

/** UploadMonStatAircraftModel */
export interface UploadMonStatAircraftModel {
    ufid?: string;
    acid?: string;
    origin?: string;
    origDepTime?: string;
    monStat?: MonitorStatusEnum;
    flightStat?: FlightStatusEnum;
    dest?: string;
    acType?: string;
    regNum?: string;
    destAlt1?: string;
    destAlt2?: string;
    lastDest?: string;
    deskID?: string;
    depTime?: string;
    arrTime?: string;
    out?: string;
    off?: string;
    on?: string;
    in?: string;
    altitude?: number;
    speed?: number;
    distPercent?: number;
    onGround?: boolean;
    holding?: boolean;
    diverting?: boolean;
    fob?: number;
    fobUnit?: FOBUnitEnum;
    lastPosUpdate?: string;
    lastFullUpdate?: string;
    aircraftThresholds?: UploadMonStatAircraftThresholdModel[];
}

/** UploadMonStatAircraftThresholdModel */
export interface UploadMonStatAircraftThresholdModel {
    type?: AircraftThresholdTypeEnum;
    triggerVal?: string;
    actualVal?: string;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
    uploadNotificationStatuses?: UploadNotificationStatus[];
}

/** UploadMonStatAirportModel */
export interface UploadMonStatAirportModel {
    icao?: string;
    iata?: string;
    name?: string;
    lat?: number;
    lon?: number;
    orgCount?: number;
    dstCount?: number;
    altCount?: number;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
    airportThresholds?: UploadMonStatAirportThresholdModel[];
}

/** UploadMonStatAirportThresholdModel */
export interface UploadMonStatAirportThresholdModel {
    type?: AirportThresholdTypeEnum;
    triggerVal?: string;
    actualVal?: string;
    monStat?: MonitorStatusEnum;
    lastUpdate?: string;
    uploadNotificationStatuses?: UploadNotificationStatus[];
}

/** UploadMonitorDataRequestModel */
export interface UploadMonitorDataRequestModel {
    dmGroupID?: string;
    seqNum?: number;
    apiKey?: string;
    curUpdateTime?: string;
    prevUpdateTime?: string;
    aircraftList?: UploadMonStatAircraftModel[];
    airportList?: UploadMonStatAirportModel[];
}

/** UploadMonitorDataResponseModel */
export interface UploadMonitorDataResponseModel {
    responseCode?: number;
}

/** UploadNotificationStatus */
export interface UploadNotificationStatus {
    userDbId?: number;
    notificationSendTime?: string;
    thresholdUpdateTime?: string;
    notificationAlertType?: NotificationAlertTypeEnum;
    notificationAlertStatus?: NotificationAlertStatusEnum;
}

/** UserMonitorSettingsSet */
export interface UserMonitorSettingsSet {
    currentFEWebVersion?: string;
    currentDbFEWebVersion?: number;
    originalFEWebVersion?: string;
    originalDbFEWebVersion?: number;
    id?: string;
    lastUpdate?: string;
    monitorOptions?: MonitorOptionsModel;
    airportThresholds?: AirportThresholdsModel;
    aircraftThresholds?: AircraftThresholdItemModel[];
    Type?: MonitorSettingsType;
}

/** WaypointModel */
export interface WaypointModel {
    id?: string;
    lt?: number;
    ln?: number;
    at?: number;
    sd?: number;
    ete?: number;
    tp?: WayPointTypeEnum;
    fob?: number;
    wd?: number;
    ay?: string;
}

/** WeatherModel */
export interface WeatherModel {}

/** routeTypeDTOModdel */
export interface routeTypeDTOModdel {
    bitmap?: ReRouteTypeEnum;
}

export type AdvisoryActionEnum = 0 | 1 | 2 | 3 | 4;

export type AdvisoryCategoryEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type AircraftThresholdType =
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39
    | 40
    | 41
    | 42
    | 43
    | 44
    | 45
    | 46
    | 47
    | 48
    | 49
    | 50
    | 51
    | 52
    | 53
    | 54
    | 55
    | 56
    | 57
    | 58
    | 59
    | 60
    | 61
    | 62;

export type AircraftThresholdTypeEnum =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29;

export type AirportDelayTrendEnum = 1 | 2;

export type AirportDelayTypeEnum = 1 | 2 | 3 | 4 | 5;

export type AirportThresholdGroupUsage = 0 | 1 | 2 | 3;

export type AirportThresholdType =
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24;

export type AirportThresholdTypeEnum =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22;

export type AirportType = 1 | 2 | 3;

export type AlertEnum = 0 | 1 | 2 | 3 | 4;

export type AltUnitEnum = 0 | 1;

export type BITMAPEnum = 1 | 2 | 3 | 4 | 8 | 16 | 32 | 48 | 64 | 128 | 256 | 512 | 768;

export type ClientTypeEnum = 0 | 1 | 99;

export type CompanyThresholdsMode = 0 | 1 | 2 | 3;

export type DayOfWeek = 1 | 2 | 4 | 8 | 16 | 32 | 64;

export type DrawingObjectCategory = 0 | 1 | 2;

export type DrawingObjectCenterStyle = 0 | 1 | 2 | 3 | 4 | 5;

export type DrawingObjectCenterUnits = 0 | 1;

export type DrawingObjectFillStyle = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type DrawingObjectLabelAlignment = 0 | 1 | 2 | 3;

export type DrawingObjectLineType = 0 | 1 | 2 | 3;

export type DrawingObjectOffsetUnits = 0 | 1;

export type DrawingObjectType = 0 | 1 | 2;

export type FAADelayTrendEnum = 0 | 1 | 2;

export type FAADelayTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type FCAConditionEnum = 0 | 1;

export type FCAType = 0 | 1 | 2 | 4 | 8 | 16;

export type FOBUnitEnum = 0 | 1 | 2;

export type FOBunitTypeEnum = 0 | 1 | 2 | 3 | 4;

export type FPMSync = 0 | 1;

export type FeedTypeEnum = 1 | 2;

export type FeedbackEnum = 0 | 1 | 2 | 3 | 4;

export type FilterGroupType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export type FlightDetailsEnum = 1 | 2;

export type FlightStatusEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type FuelUnitEnum = 1 | 3;

export type GetLastKnowLocationTypeEnum = 1 | 2 | 3;

export type MonitorSettingsType = 0 | 1;

export type MonitorStatusEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type NavTypeEnum = 0 | 1 | 2 | 3;

export type NoteType = 0 | 1 | 2 | 3;

export type NotificationAlertStatusEnum = 0 | 1 | 2;

export type NotificationAlertTypeEnum = 0 | 1 | 2 | 3 | 4 | 5;

export type PointTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 255;

export type ReRouteTypeEnum = 1 | 2 | 4 | 8 | 12 | 16 | 32 | 48 | 64;

export type RouteRquestTypeEnum = 1 | 2 | 4 | 8;

export type RouteSourceEnum = 0 | 1;

export type RouteTypeEnum = 0 | 1 | 2 | 4;

export type ShapeTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type SpeedUnitEnum = 0 | 2 | 3;

export type ThresholdEnableState = 0 | 1 | 2;

export type ThresholdLevel = 0 | 1 | 2 | 3 | 4;

export type ThresholdLevelActionType = 0 | 1 | 2 | 3;

export type UDViewDayNightShadingType = 0 | 1 | 2;

export type UDViewDayNightTwilightType = 0 | 1 | 2 | 4 | 8;

export type UDViewDestinationTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type UDViewFlightFilterObjectEnum = 0 | 1 | 2 | 3;

export type UDViewHeatMapStyle = 0 | 1 | 2 | 3 | 4;

export type UDViewMapStyle = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export type UDViewPlaneFilterAirlineTypeEnum = 1 | 2 | 3;

export type UDViewPlaneFilterAutoZoomEnum = 0 | 1 | 2;

export type UDViewPlaneIconSizeEnum = 0 | 1 | 2 | 3 | 4 | 5;

export type UDViewPlaneIconTypeEnum = 0 | 1 | 2;

export type UDViewRangeType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type UDViewShowFlightPlanTimeEnum = 0 | 1 | 2;

export type UDViewTagFilterColor = 0 | 1;

export type UDViewTagOutlineMode = 0 | 1 | 2;

export type UDViewTagSelectionEnum =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37
    | 38
    | 39
    | 40
    | 41
    | 42
    | 43
    | 44
    | 45
    | 46
    | 47
    | 48
    | 49
    | 50
    | 51
    | 52
    | 53
    | 54
    | 55
    | 56
    | 57
    | 58
    | 59
    | 60
    | 61
    | 62
    | 63
    | 64
    | 65
    | 67
    | 68
    | 69
    | 70
    | 71
    | 72
    | 73
    | 74
    | 75
    | 76
    | 77
    | 78
    | 79
    | 80
    | 81
    | 82
    | 83
    | 84
    | 85
    | 86
    | 87
    | 88
    | 89
    | 90;

export type UDViewTimeDistanceMode = 0 | 1;

export type UDViewTimeFilterTypeEnum = 0 | 1 | 2;

export type UDViewType = 0 | 1;

export type UDViewWindDepiction = 0 | 1 | 2;

export type UDViewWindParticleColor = 0 | 1 | 2;

export type UsageTypeEnum = 0 | 1 | 2 | 3;

export type WayPointTypeEnum =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31
    | 32
    | 33
    | 34
    | 35
    | 36
    | 37;

export type WeatherMetarEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13;

export type WindUnitEnum = 0 | 1 | 2;

export type eEtopsAirportFunctionTypeEnum = 0 | 1 | 2 | 3 | 4;
